import React from "react";
import Game from "./Game";
import { render, getConfig, CONTENT_TYPE, initErrorMonitoring } from "@educaplay/core";
import { assetsUrl, GameProvider } from "@educaplay/core";
import { initialize } from "@educaplay/store";
import { WORD_DIRECTIONS, SOPA_SOUNDS } from "./utils/consts";
import ResultsScreen from "./resultComponents/ResultsScreen";
import { createCustomization } from "@educaplay/core/utils/customization";

initErrorMonitoring("https://ce7b2f12e4030939bdf910c0a48c1cce@o4509038211104768.ingest.de.sentry.io/4510301857710160", {
  tracesSampleRate: 0.05
});

const SOPA_SOUNDS_CONFIG = {
  [SOPA_SOUNDS.MOUSE_HOVER]: assetsUrl('SOPA/mouse-hover.mp3'),
  [SOPA_SOUNDS.CARGAR_LETRA]: assetsUrl('SOPA/carga-letra.mp3'),
  [SOPA_SOUNDS.MOVER_LETRA]: assetsUrl('SOPA/mover-letra.mp3'),
  [SOPA_SOUNDS.LETRA_OK]: assetsUrl('SOPA/letra-ok.mp3'),
  [SOPA_SOUNDS.LETRA_ERROR]: assetsUrl('SOPA/letra-error.mp3'),
  [SOPA_SOUNDS.CORRECT_WORD]: assetsUrl('SOPA/correct-word.mp3')
};
const gameImage = assetsUrl("SOPA/logoActivity.png");
const container = document.getElementById("root");

const alphabets = [];

const buildAlphabet = (alphabet) => {
  if (alphabets[alphabet] === undefined) {
    const dictionary = {
      latin: [
        { start: 65, end: 65, weigth: 3 },
        { start: 66, end: 68 },
        { start: 69, end: 69, weigth: 3 },
        { start: 70, end: 72 },
        { start: 73, end: 73, weigth: 3 },
        { start: 74, end: 78 },
        { start: 79, end: 79, weigth: 3 },
        { start: 80, end: 84 },
        { start: 85, end: 85, weigth: 3 },
        { start: 86, end: 90 },
      ],
      numbers: [{ start: 48, end: 57 }],
      han: [{ start: 19968, end: 40959 }],
      katakana: [{ start: 12449, end: 12538 }],
      hiragana: [{ start: 12353, end: 12436 }],
      bopomofo: [{ start: 12549, end: 12585 }],
      hangul: [
        { start: 4352, end: 4370 },
        { start: 4449, end: 4469 },
        { start: 4520, end: 4546 },
      ],
      devanagari: [{ start: 2308, end: 2361 }],
      bengali: [
        { start: 2437, end: 2444 },
        { start: 2447, end: 2448 },
        { start: 2451, end: 2472 },
        { start: 2474, end: 2480 },
        { start: 2482, end: 2482 },
        { start: 2486, end: 2489 },
      ],
      thai: [{ start: 3585, end: 3630 }],
      ethiopic: [
        { start: 4608, end: 4680 },
        { start: 4682, end: 4685 },
        { start: 4688, end: 4694 },
        { start: 4696, end: 4696 },
        { start: 4698, end: 4701 },
        { start: 4704, end: 4744 },
        { start: 4746, end: 4749 },
        { start: 4752, end: 4784 },
        { start: 4786, end: 4789 },
        { start: 4792, end: 4798 },
        { start: 4800, end: 4800 },
        { start: 4802, end: 4805 },
        { start: 4808, end: 4822 },
        { start: 4824, end: 4880 },
        { start: 4882, end: 4885 },
        { start: 4888, end: 4954 },
      ],
      arabic: [
        { start: 1569, end: 1569 },
        { start: 1575, end: 1594 },
        { start: 1601, end: 1610 },
      ],
      hebrew: [{ start: 1488, end: 1514 }],
      greek: [
        { start: 913, end: 929 },
        { start: 931, end: 937 },
      ],
      cyrillic: [{ start: 1040, end: 1071 }],
    };
    const rangeBlock = [];
    if (dictionary[alphabet].length > 1) {
      let initialRangeBlock = 0;
      dictionary[alphabet].forEach((range, indexRange) => {
        let weigth;
        if (range.weigth === undefined) {
          weigth = range.end - range.start;
        } else {
          weigth = range.weigth - 1;
        }
        rangeBlock[indexRange] = initialRangeBlock + weigth;
        initialRangeBlock += weigth + 1;
      });
    } else {
      rangeBlock[0] = 0;
    }
    alphabets[alphabet] = {
      dictionary: dictionary[alphabet],
      range: rangeBlock,
    };
  }
};

const getRandomLetter = (alphabet) => {
  buildAlphabet(alphabet);
  let idBlock = 0;
  if (alphabets[alphabet].range.length > 1) {
    const randomIndex = Math.trunc(
      Math.random() *
      (alphabets[alphabet].range[alphabets[alphabet].range.length - 1] + 1)
    );
    let i = 0;
    do {
      idBlock = i;
      i++;
    } while (
      i < alphabets[alphabet].range.length &&
      randomIndex > alphabets[alphabet].range[i - 1]
    );
  }
  const code =
    Math.trunc(
      Math.random() *
      (alphabets[alphabet].dictionary[idBlock].end -
        alphabets[alphabet].dictionary[idBlock].start +
        1)
    ) + alphabets[alphabet].dictionary[idBlock].start;
  return String.fromCharCode(code);
};

/**
 *
 * @param {*} wordData
 * @param {*} wordDist
 * @param {*} resources
 * @returns {Answer}
 */
function api2game(wordData, wordDist, resources) {
  const direction = WORD_DIRECTIONS[wordDist.direction];

  return {
    content: wordData.RESPUESTA,
    type: wordData.MULTIMEDIA_TIPO ?? CONTENT_TYPE.TEXT,
    src: wordData.MULTIMEDIA
      ? `${resources ?? ""}${wordData.MULTIMEDIA}`
      : undefined,
    hideText: wordData.MULTIMEDIA_SOLO ?? false,
    direction,
    position: { x: wordDist.column, y: wordDist.row },
  };
}

/**
 *
 * @param {*} question
 * @param {*} resources
 * @returns {Answer[]}
 */
function formatCorrectAnswers(question, resources) {
  const words = [];

  for (let i = 0; i < question.RESPUESTAS.length; i++) {
    words.push(
      api2game(
        question.RESPUESTAS[i],
        question.distribution.words[i],
        resources
      )
    );
  }

  return words;
}

function soupFilling(question, resources) {
  const distro = question.distribution;
  const alphabet = distro.alphabet;
  const gridSize = distro.rows;
  const words = formatCorrectAnswers(question, resources);

  const letters = [];

  for (let i = 0; i < gridSize; i++) {
    const col = [];
    for (let j = 0; j < gridSize; j++) {
      col.push(getRandomLetter(alphabet));
    }
    letters.push(col);
  }

  words.forEach((word) => {
    const content = word.content;
    const wLength = content.length;

    const direction = word.direction;

    let actualPos = word.position;

    for (let i = 0; i < wLength; i++) {
      letters[actualPos.y][actualPos.x] = content.charAt(i);
      actualPos = {
        x: actualPos.x + direction.x,
        y: actualPos.y + direction.y,
      };
    }
  });
  const formattedData = [];
  letters.forEach((c, y) => {
    c.forEach((l, x) => {
      formattedData.push({
        letter: l.toUpperCase(),
        id: y * gridSize + x,
        position: { x: x, y: y },
      });
    });
  });

  return formattedData;
}

async function init() {
  const { data, texts, settings, user, title, description, author, id } =
    await getConfig().catch(() => { });

  const { resources } = settings;
  const hideBank = data.PISTAS === "ninguna";

  const filteredQuestions = data.PREGUNTAS.map((question, index) => {
    const filteredAnswers = [];

    question.RESPUESTAS.forEach((ans) => {
      if (ans.RESPUESTA.trim().length > 1) {
        filteredAnswers.push(ans);
      }
    });

    return {
      ...question,
      id: index,
      RESPUESTAS: filteredAnswers,
    };
  }).filter((question) => question.RESPUESTAS && question.RESPUESTAS.length > 0 && question.distribution !== false);

  const questionTimeNumber = Number(data.TIEMPO);
  const questionTime = Number.isNaN(questionTimeNumber)
    ? 0
    : questionTimeNumber;

  const questions = filteredQuestions.map((question) => {
    return {
      bank: null,
      checkAnswer: (answer) => {
        if (!answer) return false;
        return answer.length !== 0 && answer[answer.length - 1].enunId !== -1;
      },
      calculatePoints: (answer) => {
        if (answer[answer.length - 1].enunId === -1) return;

        const soupPoints = 100 / filteredQuestions.length;
        const wordPoints = soupPoints / question.RESPUESTAS.length;
        const wrongs = answer.filter((it) => it.enunId === -1).length;
        const pointMult = wrongs > 2 ? 0 : 1 / 2 ** wrongs;
        const penalties = data.NUMERO_INTENTOS_INFINITOS !== "si";

        return wordPoints * (penalties ? pointMult : 1);
      },
      correctAnswers: formatCorrectAnswers(question, resources),
      answer: null,
      points: 100 / filteredQuestions.length,
      time: questionTime,
      id: question.id,
      tiles: soupFilling(question, resources),
      gridSize: question.distribution.rows,
    };
  });
  initialize({
    countFooterSpace: true,
    lives: data.NUMERO_INTENTOS,
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.MAXIMO === "si",
    randomized: data.ALEATORIO === "si",
    showSolutions: data.OCULTAR_RESPUESTAS !== "1",
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    hasInfinityTries: true,
    hasBank: !hideBank,
    questions,
    settings,
    title,
    description,
    author,
    id,
    user,
    customizations: createCustomization(data)
  });

  render(
    container,
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        sounds={SOPA_SOUNDS_CONFIG}
        mappers={{
          report: (question) => {
            /** @type {WordSelection[]} */
            const answer = question.answer;
            const id = question.id;

            const formattedAnswers = [];
            answer.forEach((element) => {
              const unNumero = element.enunId;

              formattedAnswers.push({
                s: element.state === 1,
                i: element.state === 1 ? `${id}:${unNumero}` : id,
                a: element.word,
              });
            });

            return [...formattedAnswers];
          },
        }}
        renders={{
          results: (questions) => {
            const finalQuestions = questions.map((q) => {
              const foundWords = q.answer?.filter((/** @type {WordSelection} */ it) => it.enunId !== -1) || [];
              const foundIndices = new Set(foundWords.map(word => word.enunId));
              const allAnswers = [];

              foundWords.forEach((/** @type {WordSelection} */ it) => {
                const foundEnun = q.correctAnswers[it.enunId];
                allAnswers.push({
                  TEXT: it.word,
                  MULTIMEDIA_TIPO: foundEnun?.type ?? CONTENT_TYPE.TEXT,
                  MULTIMEDIA: foundEnun?.src ?? undefined,
                  correct: true,
                });
              });

              q.correctAnswers.forEach((/** @type {Answer} */ correctAnswer, index) => {
                if (!foundIndices.has(index)) {
                  allAnswers.push({
                    TEXT: correctAnswer.content,
                    MULTIMEDIA_TIPO: correctAnswer.type ?? CONTENT_TYPE.TEXT,
                    MULTIMEDIA: correctAnswer.src ?? undefined,
                    correct: false,
                  });
                }
              });

              return {
                ...q,
                answer: allAnswers,
              };
            });

            return (
              <ResultsScreen
                hideEnunciado
                hideAnswers
                correctSingleAnswers
                questions={finalQuestions}
              />
            );
          },
        }}
      />
    </React.StrictMode>
  );
}

init();
